import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useTheme } from "styled-components";
import Svg from "../Svg";
var Icon = function(props) {
    var theme = useTheme();
    var primaryColor = theme.isDark ? "#CECCDA" : "#093174";
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: "17",
        height: "16",
        viewBox: "0 0 17 16"
    }, props), {
        children: /*#__PURE__*/ _jsxs("svg", {
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.1459 0.645917C11.1924 0.599354 11.2475 0.562411 11.3083 0.537205C11.369 0.511998 11.4341 0.499023 11.4999 0.499023C11.5657 0.499023 11.6308 0.511998 11.6915 0.537205C11.7523 0.562411 11.8075 0.599354 11.8539 0.645917L15.8539 4.64592C15.9005 4.69236 15.9374 4.74754 15.9626 4.80828C15.9878 4.86903 16.0008 4.93415 16.0008 4.99992C16.0008 5.06568 15.9878 5.13081 15.9626 5.19155C15.9374 5.2523 15.9005 5.30747 15.8539 5.35392L13.9519 7.25592L13.1229 10.5689C13.0599 10.8212 12.9323 11.0527 12.7528 11.2408C12.5733 11.4289 12.348 11.5672 12.0989 11.6419L1.75391 14.7459L4.85791 4.39992C4.93272 4.15118 5.07085 3.92613 5.25877 3.7468C5.44668 3.56748 5.67794 3.44002 5.92991 3.37692L9.24291 2.54892L11.1459 0.645917ZM9.34591 3.55392L6.17291 4.34692C6.08868 4.36794 6.01138 4.41053 5.9486 4.4705C5.88583 4.53046 5.83975 4.60574 5.81491 4.68892L3.24491 13.2539L11.8119 10.6839C11.8946 10.6589 11.9694 10.6128 12.029 10.5502C12.0886 10.4877 12.1309 10.4107 12.1519 10.3269L12.9459 7.15292L9.34591 3.55292V3.55392Z",
                    fill: primaryColor
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3.33209 13.228L8.50009 9C8.69787 9 8.89121 8.94135 9.05566 8.83147C9.22011 8.72159 9.34829 8.56541 9.42397 8.38268C9.49966 8.19996 9.51946 7.99889 9.48088 7.80491C9.44229 7.61093 9.34705 7.43275 9.2072 7.29289C9.06735 7.15304 8.88916 7.0578 8.69518 7.01922C8.5012 6.98063 8.30014 7.00043 8.11741 7.07612C7.93468 7.15181 7.77851 7.27998 7.66862 7.44443C7.55874 7.60888 7.50009 7.80222 7.50009 8L3.27209 13.168L3.24609 13.254L3.33209 13.228Z",
                    fill: primaryColor
                })
            ]
        })
    }));
};
export default Icon;
